/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Custombusinessaddress2Inputs */

const de__field_custombusinessaddress2 = /** @type {(inputs: _Field_Custombusinessaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstadresse*`)
};

/**

* @param {_Field_Custombusinessaddress2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_custombusinessaddress2 = /** @type {((inputs?: _Field_Custombusinessaddress2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Custombusinessaddress2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_custombusinessaddress2(inputs)
});
export { _field_custombusinessaddress2 as "_field_customBusinessAddress" }